export const domainEmailsDataSelector = (state) => state.emails.data;
export const domainEmailsCurrentSelector = (state) => state.emails.currentEmail;
